// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"style__toolbar___3HdGh"};